<ul class="{{listClass}}">
  @for (item of listItemArray; track item; let i = $index; let last = $last) {
    <li>
      <div class="item {{item.indicatorClass}}"
        [class.last]="last"
        (click)="navTo(item)"
        [class.item-margin]="!item.dismissable">
        <div class="symbol">
          @if (type === ListTypes.Links) {
            <img
              src="{{ item.symbol || item.defaultSymbol }}"
              [alt]="'common:textDefaultIcon' | ycI18n : 'Default Icon'" />
          }
          @if (type === ListTypes.Alerts) {
            <yc-fa
              icon="circle">
            </yc-fa>
          }
          @if (type === ListTypes.Notifications) {
            <yc-fa
              [icon]="item.symbol">
            </yc-fa>
          }
        </div>
        <div class="content">
          <div class="title" [innerHtml]="item.title"></div>
          <div class="sub-title" [innerHtml]="item.subtitle"></div>
        </div>
        @if (type === ListTypes.Links) {
          <div class="actions">
            <yc-fa icon="angle-right"></yc-fa>
          </div>
        }
        @if (type === ListTypes.Notifications) {
          <div
            class="bullet">
            <yc-fa
              class="indicator text-{{item.indicatorClass}}"
              [icon]="bulletIcon(item.indicatorClass)">
            </yc-fa>
            <yc-fa class="navTo text-primary"
              icon="arrow-circle-right">
            </yc-fa>
          </div>
        }
      </div>
      @if (item.dismissable) {
        <div class="footer">
          <yc-button
            [link]="true"
            size="sm"
            (onClick)="_onDismiss(item.id)">
            <yc-i18n
              key="common:btnDismiss"
              defaultValue="Dismiss">
            </yc-i18n>
          </yc-button>
        </div>
      }
      @if (last) {
        <hr>
        }
      </li>
    }
  </ul>
